export default "__VITE_ASSET__DI5V$xBs__"